import { render } from "./AddRound.vue?vue&type=template&id=ae6708c0&scoped=true"
import script from "./AddRound.vue?vue&type=script&lang=js"
export * from "./AddRound.vue?vue&type=script&lang=js"

import "./AddRound.vue?vue&type=style&index=0&id=ae6708c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae6708c0"]])

export default __exports__